module.exports = __webpack_public_path__ + "media/hot.b576a2fc.wav";